
import "../src/filer/filer2.js";
import "../src/stock/report_error.js";
import "../src/stock/email_registration.js";
import "../src/filer/email_alert_dialog.js";


//import * as peer from './filer/filer_peer_groups.js';
import "core-js/stable";
import "regenerator-runtime/runtime";

//import "@babel/polyfill";
//import "core-js/fn/symbol/iterator.js";
//import "core-js/es6/symbol.js";

document.addEventListener('DOMContentLoaded', () => {
    console.log("dom loaded");

})

